/* Generated by tools/build-localization.mjs. Do not edit by hand. */
const ru = {
  "about.body": "Мы — группа друзей, которая начала исследовать древние и гигантские деревья Кипра, а затем путешествовать по острову, чтобы найти и сфотографировать их. Этот каталог объединяет проделанную работу.",
  "about.corrections": "Нашли ошибку или знаете дерево, которого ещё нет в каталоге? Напишите нам: укажите название и место, что исправить или добавить, и по возможности приложите фотографии или ссылку на источник.",
  "about.licensing": "Наши фотографии сделаны командой Cyprus Trees. Внешние фотографии ссылаются на страницу, где они были найдены, а каждая запись о дереве содержит свои исследовательские источники.",
  "about.title": "О проекте",
  "catalogue.empty": "Этим фильтрам не соответствуют никакие деревья. Очистите фильтры, чтобы увидеть полный каталог.",
  "catalogue.error": "Не удалось загрузить каталог. Проверьте соединение и обновите страницу.",
  "catalogue.filter.age": "Возраст",
  "catalogue.filter.ageAny": "Любой возраст",
  "catalogue.filter.ageBand": "{{from}}–{{to}} лет",
  "catalogue.filter.ageOldest": "1000 лет и старше",
  "catalogue.filter.ageUnrecorded": "Данных о возрасте нет",
  "catalogue.filter.apply": "Показать: {{count}}",
  "catalogue.filter.clear": "Очистить фильтры",
  "catalogue.filter.close": "Закрыть фильтры",
  "catalogue.filter.done": "Готово",
  "catalogue.filter.filters": "Фильтры",
  "catalogue.filter.maxAge": "До, лет",
  "catalogue.filter.minAge": "От, лет",
  "catalogue.filter.noSpecies": "Виды не найдены",
  "catalogue.filter.onlyUnknownAge": "Только без данных о возрасте",
  "catalogue.filter.remove": "Убрать: {{label}}",
  "catalogue.filter.search": "Искать по названию, виду или деревне",
  "catalogue.filter.searchSpecies": "Найти вид",
  "catalogue.filter.selected": "Выбрано: {{count}}",
  "catalogue.filter.shortSearch": "Найти дерево",
  "catalogue.filter.species": "Виды",
  "catalogue.filter.speciesAny": "Все виды",
  "catalogue.results": "Деревьев: {{count}}",
  "catalogue.title": "Деревья",
  "copy.action": "Скопировать: {{label}}",
  "copy.failure": "Не удалось скопировать. Выделите и скопируйте текст.",
  "copy.success": "Скопировано: {{label}}",
  "count.catalogue": "Деревья в каталоге",
  "district.famagusta": "Фамагуста",
  "district.kyrenia": "Кирения",
  "district.larnaca": "Ларнака",
  "district.limassol": "Лимасол",
  "district.nicosia": "Никосия",
  "district.paphos": "Пафос",
  "footer.navigation": "Навигация в футере",
  "footer.note": "Каталог, составленный группой друзей, путешествующих по Кипру.",
  "gallery.close": "Закрыть галерею",
  "gallery.next": "Далее",
  "gallery.openPhoto": "Открыть фотографию {{index}} из {{total}}",
  "gallery.position": "{{index}} из {{total}}",
  "gallery.previous": "Назад",
  "gallery.title": "Фотографии деревьев",
  "gallery.viewAll": "Посмотреть все ({{count}})",
  "hero.body": "Растущий каталог и карта замечательных старых деревьев по всему Кипру, составленные на основе опубликованных источников и наших путешествий по острову.",
  "hero.title": "Древние деревья Кипра",
  "language.switch": "Язык",
  "location.hint": "Наша команда ещё не подтвердила, что это дерево находится именно здесь.",
  "location.uncertain": "Место?",
  "location.unknown": "Место неизвестно",
  "map.attribution": "© Участники OpenStreetMap",
  "map.listTitle": "Деревья на карте",
  "map.title": "Карта деревьев",
  "meta.catalogueDescription": "Просмотрите {{count}} древних, гигантских и примечательных деревьев по всему Кипру по видам и возрасту, с фотографиями, местоположениями и описаниями, подтвержденными источниками.",
  "meta.homeDescription": "Исследуйте древние, гигантские и примечательные деревья по всему Кипру в многоязычном полевом каталоге с фотографиями, источниками исследований и интерактивной картой.",
  "meta.imageAlt": "Эмблема кипрских монументальных деревьев — нарисованное от руки оливковое дерево с контуром Кипра",
  "meta.mapDescription": "Найдите древние, гигантские и примечательные деревья по всему Кипру на интерактивной карте с фотографиями и четко отмеченными непроверенными точками.",
  "meta.treeDescription": "Исследуйте {{name}} недалеко от {{place}}, с фотографиями, подробностями местоположения и источниками исследований из каталога «Древние деревья Кипра».",
  "nav.catalogue": "Деревья",
  "nav.map": "Карта",
  "nav.primary": "Основная навигация",
  "notFound.page": "Эта страница не найдена. Вернуться к каталогу деревьев.",
  "photo.creditTeam": "© Команда Cyprus Trees",
  "photo.creditVia": "Источник фото: {{host}}",
  "photo.pending": "У нас пока нет фотографии этого дерева.",
  "photo.unavailable": "Фотография недоступна",
  "plaque.age": "Возраст",
  "plaque.coordinates": "Координаты",
  "plaque.district": "Округ",
  "plaque.girth": "Обхват",
  "plaque.height": "Высота",
  "plaque.meters": "м",
  "plaque.protection": "Охрана",
  "plaque.protectionMonument": "Памятник природы",
  "plaque.species": "Вид",
  "plaque.title": "Данные",
  "plaque.unknown": "Нет данных",
  "plaque.village": "Деревня",
  "rule.label": "Возраст каждого задокументированного дерева",
  "rule.none": "Возраст неизвестен",
  "sheet.access": "Доступ",
  "sheet.funFacts": "Подробности",
  "sheet.mapsLink": "Открыть в Google Картах",
  "sheet.notFound": "Этого дерева нет в каталоге. Возможно, оно было удалено, объединено с другой записью или неправильно связано.",
  "sheet.sources": "Источники",
  "sheet.sourcesOwnFieldwork": "Эта запись получена из наших полевых фотографий и их координат; отдельный опубликованный источник не указан.",
  "sheet.whereItStands": "Местоположение",
  "site.title": "Древние деревья Кипра",
  "species.calabrianPine": "Сосна калабрийская",
  "species.carob": "Рожковое дерево",
  "species.cypress": "Кипарис",
  "species.ficus": "Фикус",
  "species.goldenOak": "Дуб золотистый",
  "species.grapevine": "Виноград",
  "species.juniper": "Можжевельник",
  "species.kermesOak": "Кермесовый дуб",
  "species.laurel": "Лавр",
  "species.multiple": "Несколько видов",
  "species.oak": "Дуб",
  "species.olive": "Олива",
  "species.other": "Другие виды",
  "species.pine": "Черная сосна",
  "species.pineUnspecified": "Сосна",
  "species.plane": "Восточный платан",
  "species.planeUnspecified": "Платан",
  "species.stonePine": "Пиния",
  "species.strawberryTree": "Земляничное дерево",
  "species.sycomoreFig": "Сикомор",
  "species.terebinth": "Скипидарное дерево",
  "species.tipuana": "Типуана",
  "theme.dark": "Темная",
  "theme.light": "Светлая",
  "theme.toDark": "Переключиться на темную тему",
  "theme.toLight": "Переключиться на светлую тему",
  "tree.ageLabel": "Возраст: {{label}} лет",
  "tree.ageYears": "Возраст: {{count}} лет",
  "tree.backToLedger": "Вернуться ко всем деревьям",
  "tree.name": "Название",
  "tree.speciesUnrecorded": "Вид не зарегистрирован",
  "visit.hint": "Наша команда ещё не посещала это дерево и не делала здесь свои фотографии.",
  "visit.notVisited": "Не посещено",
} as const;

export default ru;
